import { ChangeDetectorRef, Component, ComponentRef, ViewChild } from '@angular/core';

import {
  BasePortalHost,
  ComponentPortal,
  PortalHostDirective,
  TemplatePortal,
} from '../../core/core.module';

@Component({
  selector: 'rt-notifications-container',
  template: ` <ng-template portalHost></ng-template> `,
  styleUrls: ['./notifications-container.component.less'],
})
export class NotificationsContainerComponent extends BasePortalHost {
  @ViewChild(PortalHostDirective, { static: true }) public _portalHost: PortalHostDirective;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  public attachTemplatePortal(portal: TemplatePortal): Map<string, any> {
    return this._portalHost.attachTemplatePortal(portal, 0);
  }

  public attachComponentPortal<T>(portal: ComponentPortal<T>, index: number = 0): ComponentRef<T> {
    const componentRef = this._portalHost.attachComponentPortal(portal, index);
    return componentRef;
  }

  public refresh(): void {
    this.cdRef.detectChanges();
  }
}
